import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { SEO } from '@/components/SEO';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/sections/Footer';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <SEO
        title="Pagina Non Trovata - 404 - Brace e Sapori Store"
        description="La pagina che stai cercando non esiste o è stata spostata. Torna alla home o esplora il nostro catalogo prodotti."
        noindex={true}
      />
      <Header />
      <main className="flex min-h-screen items-center justify-center bg-muted pt-24 pb-16">
        <div className="text-center px-4">
          <h1 className="mb-4 text-4xl font-bold">404</h1>
          <p className="mb-4 text-xl text-muted-foreground">Pagina non trovata</p>
          <p className="mb-6 text-muted-foreground">
            La pagina che stai cercando non esiste o è stata spostata.
          </p>
          <a href="/" className="text-primary underline hover:text-primary/90">
            Torna alla Home
          </a>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default NotFound;
